import Player from "@/components/LottiePlayer";

export default function MoreFeatures() {
  const features = [
    {
      title: "ASSESS YOUR DATA MATURITY",
      text: "Our team will work with you to evaluate your organization's current data maturity level, identifying strengths, weaknesses, and areas for improvement.",
      icon: "/assets/icons/data-portal.json"
    },
     {
      title: "ALIGN DATA GOALS WITH BUSINESS OBJECTIVES",
      text: "We'll collaborate with you to ensure that your data strategy supports your overarching business goals.",
      icon: "/assets/icons/seeding.json"
    },
    {
      title: "CREATE A DATA VALUE FRAMEWORK",
      text: "Together, we will develop a framework that identifies, quantifies, and prioritizes the value generated from your data assets, maximizing returns.",
      icon: "/assets/icons/expand.json"
    },
    {
      title: "ESTABLISH DATA GOVERNANCE AND COMPLIANCE",
      text: "We'll help you implement data governance policies and procedures to ensure data quality, security, and compliance with industry regulations.",
      icon: "/assets/icons/privacy-policy.json"
    },
    {
      title: "OPTIMIZE DATA ARCHITECTURE",
      text: "Our experts will optimize your data architecture for seamless integration, storage, and access, enabling enhanced analytics and decision-making capabilities.",
      icon: "/assets/icons/repair-tools.json"
    },
    {
      title: "ENHANCE DATA ACCESSIBILITY AND COLLABORATION",
      text: "We'll work with you to ensure that data is accessible and shareable across your organization, fostering collaboration and data-driven decision-making.",
      icon: "/assets/icons/connection.json"
    },
    {
      title: "IMPLEMENT ADVANCED ANALYTICS",
      text: "Our team will support you in harnessing the power of advanced analytics and visualization tools to uncover hidden insights and drive innovation.",
      icon: "/assets/icons/bar-chart-1.json"
    },
    {
      title: "CONTINUOUSLY MONITOR AND EVOLVE",
      text: "Together, we will regularly review the progress and impact of your data strategy initiatives, making data-driven adjustments to ensure long-term success.",
      icon: "/assets/icons/robot.json"
    },
    {
      title: "ONGOING SUPPORT AND PARTNERSHIP",
      text: "We provide ongoing support, resources, and partnership to help your organization leverage your data strategy effectively and drive sustainable growth.",
      icon: "/assets/icons/presentation.json"
    },
  ]
  return (
    <section className="my-16 flex flex-col items-center justify-center md:py-12 bg-white bg-center font-['Inter']">
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl container px-8 ">
        <div className="text-center text-maingray" tabIndex={0}>
          <h3 className="mb-8 text-4xl md:text-5xl tracking-tight leading-tight font-bold md:leading-tight">
            How it works
          </h3>
          <p className="body-text mb-16 xl:mb-24 mx-auto  max-w-4xl">
            A great data strategy includes a clear roadmap for maximizing the value of your organization&apos;s data assets. Discover how our tailored approach guides you through every step, from assessing your data maturity to implementing advanced analytics and ensuring long-term success. 
          </p>
        </div>
      </div>
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl grid grid-cols-1 lg:grid-cols-3 gap-14 px-4">
        {features.map((feature) => (
          <>
            <div tabIndex={0} className="p-16 flex flex-col items-center text-center rounded-3xl shadow-lg transition ease-in-out hover:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] ">
              <Player
                autoplay
                loop
                src={feature.icon}
                style={{ height: "80px", width: "80px" }}
              />
              <h3 className="font-['Inter'] text-xl font-bold text-orange-400  py-2"> {feature.title} </h3>
              <p className="body-text"> {feature.text} </p>
            </div>
            </>
        ))}
      </div>
    </section>
  );
}
